<template>
  <div>
         
<CCard>
    <!-- <CCardHeader>
        <span style="font-weight:500;font-size:24px">Change Plan</span>
    </CCardHeader> -->
    <CCardBody>
        <div class="form-group">
 <label>Card Number</label>
    <div id="card-number"></div>
        </div>
        <div class="form-group">
    <label>Card Expiry</label>
    <div id="card-expiry"></div>

        </div>
        <div class="form-group">
    <label>Card CVC</label>
    <div id="card-cvc"></div>

        </div>
    <CCardFooter>
            <b-button id="custom-button" @click="createToken">Save</b-button>

    </CCardFooter>
    </CCardBody>
</CCard>
   
  </div>
</template>

<script>
import Vue from 'vue';
import { StripePlugin } from '@vue-stripe/vue-stripe';
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
Vue.use(VueToast, {
  // One of the options
  position: "top-right",
});

const options = {
  pk: 'pk_test_51JVcs4SDtYRnBqE4a04FjUuryKgGzmkR0ReS7URp8YeiF8ft8Fgklu9d0brdVdzXphqNegBdpwnzYPExIxGC8K1w00YYFxjBYX',
  locale: 'en',
};

Vue.use(StripePlugin, options);

export default {
    name: "changeCard",

  data () {
    return {
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
    };
  },
  computed: {
    stripeElements () {
      return this.$stripe.elements();
    },
  },
  mounted () {
    // Style Object documentation here: https://stripe.com/docs/js/appendix/style
    const style = {
      base: {
        color: 'black',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '14px',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    };
    this.cardNumber = this.stripeElements.create('cardNumber', { style });
    this.cardNumber.mount('#card-number');
    this.cardExpiry = this.stripeElements.create('cardExpiry', { style });
    this.cardExpiry.mount('#card-expiry');
    this.cardCvc = this.stripeElements.create('cardCvc', { style });
    this.cardCvc.mount('#card-cvc');
  },
  beforeDestroy () {
    this.cardNumber.destroy();
    this.cardExpiry.destroy();
    this.cardCvc.destroy();
  },
  methods: {
    async createToken () {
      const { token, error } = await this.$stripe.createToken(this.cardNumber);
      if (error) {
        //   console.log(error)
        // document.getElementById('card-error').innerHTML = error.message;
        console.log(error.message);
                  Vue.$toast.error(error.message, {
            position: "top-right",
          });

        return;
      }
      console.log(token);
      // handle the token
      // send it to your server
    },
  }
};
</script>

<style scoped>
#custom-button {
  /* height: 30px; */
  outline: 1px solid red;
  float: right;
  background-color: red;
  /* padding: 5px; */
  color: white;
  font-weight: 600;
}

#card-error {
  color: red;
}
</style>

